import React from 'react';

const RadioActive = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="12" fill="#AABAC5" />
    <path
      d="M16 8L10.634 15.6646C10.3872 16.0191 9.89973 16.1065 9.54524 15.8598C9.47627 15.8118 9.41547 15.7528 9.36498 15.6856L8 13.8661"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RadioActive;
